import fetchModels from "../../mixin/store/api/fetchModels";
import pushModel from "@/mixin/store/api/pushModel";
import fetchModel from "@/mixin/store/api/fetchModel";

export default {
    actions: {
        fetchAllDiscounts(context, data) {
            let url = 'discounts?order[id]=desc'

            if (data.isSalePage) {
                let year = new Date().getFullYear()
                let month = new Date().getMonth() + 1
                let day = new Date().getDate()
                let date = '' + year + '-' + (month >= 10 ? month : '0' + month) + '-' + (day >= 10 ? day : '0' + day)
                url += '&isActive=true&startAt[before]=' + date + '&endAt[after]=' + date
            }

            return fetchModels(context, url, data.page, 'updateDiscounts');
        },
        fetchDiscount(context, id) {
            return fetchModel(context, 'discounts', id, 'updateDiscount')
        },
        putDiscount(context, data) {
            return pushModel(context, 'discounts/edit', data, 'updateDiscount')
        },
        pushDiscount(context, data) {
            return pushModel(context, 'discounts', data)
        }
    },
    mutations: {
        updateDiscounts(state, data) {
            state.discounts = data
            state.discounts.isNeedFetch = false
        },
        updateDiscountsIDB(state, data) {
            state.discounts.models = data
        },
        updateDiscount(state, data) {
            state.discount = data
        }
    },
    state: {
        discount: {},
        discounts: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        }
    },
    getters: {
        getDiscounts(state) {
            return state.discounts.models
        },
        getDiscountsTotalCount(state) {
            return state.discounts.totalItems
        },
        getDiscount(state) {
            return state.discount
        }
    },
}
